const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const clinicalFavicon = VISUALIZE__URL + "clinical-visuals-favicon-logo.svg";
const ligerFavicon = VISUALIZE__URL + "liger-favicon.svg";
const base = import.meta.env.VITE_VISUALIZE__URL;
const favDefault = clinicalFavicon;
const favObgyn = clinicalFavicon;
const favKr = base + "krh/kr_logo.png";
const ligerFavi = ligerFavicon;

const domainFavicons: { match: string; icon: string }[] = [
    { match: "obgyn", icon: favObgyn },
    { match: "kr", icon: favKr },
    { match: "liger", icon: ligerFavi },
];

export const setFavicon = () => {
    // const {logos} = useBrand()
    const host = window.location.hostname;
    const found = domainFavicons.find((d) => host.includes(d.match));
    const favicon = found?.icon || favDefault;

    let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
    }
    link.href = favicon;
    // link.href = logos.faviconUrl;
};
